import type { NewApptState } from '../types';

const selectServiceIds = (state: NewApptState) => state.newAppt.services.ids;

export { selectServiceIds };
